import Loader from 'Components/Loader';
import React from 'react';
import lamp from 'Assets/images/bell.png';
import Container from './components/Container';
import Heading from './components/Heading';
import Image from './components/Image';
import MenuContainer from './components/MenuContainer';
import SelectTicketHeader from './components/SelectTicketHeader';
import TicketSearchSection from './components/TicketSearchSection';
import WelcomeSection from './components/WelcomeSection';
import WelcomeText from './components/WelcomeText';
import axios from 'Axios';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import Button from '@material-ui/core/Button';
import SearchIcon from '@material-ui/icons/Search';
import ProjectCard from './components/Project';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Options = styled.div`
  padding: 5px 0;
  display: flex;
  align-items: center;
  width: 100%;
`;
const SortDir = styled.div`
  margin-left: 5px;
  font-weight: bold;
  padding-bottom: 1px;
`;

const StyledButton = styled(Button)``;

class SidebarTickets extends React.PureComponent {
  state = {
    projects: [],
    searchTerm: '',
    buttonProjectsClicked: false,
    buttonQueriesClicked: false,
    sort: 'date',
    order: 'desc',
  };

  handleChangeSort = prop => () => {
    this.setState(
      {
        sort: prop,
        order: this.state.order === 'asc' ? 'desc' : 'asc',
      },
      () => {
        this.props.getProjectSorted(
          this.state.searchTerm,
          this.state.sort,
          this.state.order
        );
      }
    );
  };

  componentDidUpdate(prevProps) {
    if (prevProps.tickets !== this.props.tickets) {
      this.setState({ projects: this.props.tickets });
    }
    if (prevProps.activeButton !== this.props.activeButton) {
      this.setState({ searchTerm: '' });
    }
  }

  doRemove = () => {
    axios
      .put(`/supply/ticket/${this.state.deleteThisTicket}/hide`)
      .then(response => {
        if (response) {
          let filteredTickets = this.state.filteredTickets.filter(
            ticket => ticket.ticketId !== this.state.deleteThisTicket
          );
          this.setState(
            {
              filteredTickets,
              deleteThisTicket: false,
            },
            () => {
              this.props.history.push('/supply');
            }
          );
          this.closeDeleteDialog();
        }
      })
      .catch(error => {
        // Error
        let errorMessage;
        if (error.response) {
          errorMessage = error.response.data.message;
        } else if (error.request) {
          errorMessage = error.request;
        } else {
          errorMessage = error.message;
        }
        this.setState({
          SnackbarMsg: errorMessage,
        });
      });
  };

  handleChangeSerach = e => {
    this.setState({ searchTerm: e.target.value });
    if (e.target.value === '') {
      this.props.getProjectByTerm('');
    }
  };

  render() {
    return (
      <Container>
        <TicketSearchSection>
          <MenuContainer role="button">
            <SelectTicketHeader
              $active={this.props.activeButton === 'queries'}
              onClick={this.props.getTicketsBy('queries')}
            >
              Queries
            </SelectTicketHeader>
            <SelectTicketHeader
              $active={this.props.activeButton === 'project'}
              onClick={this.props.getTicketsBy('project')}
              disabled={true}
            >
              Projects
            </SelectTicketHeader>
            <SelectTicketHeader
              $active={this.props.activeButton === 'discarded'}
              onClick={this.props.getTicketsBy('discarded')}
            >
              Discarded
            </SelectTicketHeader>
          </MenuContainer>
          <FormControl className="w100">
            <InputLabel
              htmlFor="search"
              classes={{
                root: 'label--c-gray u-pad-l-30',
              }}
            >
              Search
            </InputLabel>
            <Input
              classes={{
                underline: 'underline--c-primary u-pad-l-30',
              }}
              type="text"
              label="Search"
              value={this.state.searchTerm}
              onChange={this.handleChangeSerach}
              fullWidth
              onKeyPress={event => {
                if (event.key === 'Enter') {
                  this.props.getProjectByTerm(event.target.value);
                }
              }}
            />
            <SearchIcon className="e-pos-a c-p_gray bot5" />
          </FormControl>
        </TicketSearchSection>

        <WelcomeSection>
          <Options>
            <span>Sort: </span>
            <StyledButton onClick={this.handleChangeSort('notification')}>
              With notification
              {this.state.sort === 'notification' && (
                <SortDir>{this.state.order === 'asc' ? '↑' : '↓'}</SortDir>
              )}
            </StyledButton>

            <StyledButton onClick={this.handleChangeSort('date')}>
              Date received
              {this.state.sort === 'date' && (
                <SortDir>{this.state.order === 'asc' ? '↑' : '↓'}</SortDir>
              )}
            </StyledButton>
          </Options>
          {this.props.loading ? (
            <Loader isLoading />
          ) : this.state.projects.length === 0 ? (
            <React.Fragment>
              <Heading>
                {this.props.activeButton === 'project' &&
                  'No Projects with shortlisted Luminaires'}
                {this.props.activeButton === 'queries' &&
                  'No active Queries for your region/product range'}
                {this.props.activeButton === 'discarded' &&
                  'No discarded Queries'}
              </Heading>
              {this.props.activeButton !== 'discarded' && <Image src={lamp} />}
              <WelcomeText>
                {this.props.activeButton === 'project' &&
                  'You will be informed via email when your responses are shortlisted.'}
                {this.props.activeButton === 'queries' &&
                  'Welcome to ARUP Luminaire Broker. Lighting designers and engineers will send you queries for specific projects. You will be informed about new queries via email. Please respond as soon as possible, queries can be time limited.'}
                {this.props.activeButton === 'discarded' &&
                  'Discarded active Queries will appear here.'}
              </WelcomeText>
              <WelcomeText>
                Not sure where to start? Visit our{' '}
                <Link className="link-bellow-button" to="/faq">
                  Frequently asked questions
                </Link>
                .
              </WelcomeText>
            </React.Fragment>
          ) : (
            this.props.tickets.map((project, index) => (
              <ProjectCard
                key={project.projectName + index}
                project={project}
                removeTicketFromSideBar={this.removeTicketFromSideBar}
                id={index}
              />
            ))
          )}
        </WelcomeSection>
      </Container>
    );
  }
}

export default SidebarTickets;
